import { newsletterToPropMapping } from "lib/constants/shared";
import type { CustomFieldHookData } from "lib/hooks/useCustomFields";
import type { NewsletterVariants } from "lib/types/common";

export const wasSignedUp = (
  newsletters: CustomFieldHookData["newsletters"],
  type: NewsletterVariants
): boolean => {
  return Boolean(newsletters && newsletters[newsletterToPropMapping[type]]);
};
